import React from 'react';
import PropTypes from 'prop-types';
import { formatUsd, roundMoney } from '../../utils/nonRxTax';
import './PriceTaxTotalSummary.css';

const PriceTaxTotalSummary = ({
  t,
  price,
  tax,
  isPercent,
  showEach,
  className,
}) => {
  const priceValue = roundMoney(price);
  const taxValue = roundMoney(tax);
  const totalValue = priceValue + taxValue;
  const eachSuffix = showEach
    ? ` ${t('NonRxCatalog.EachAbbrev', { defaultValue: 'ea' })}`
    : '';

  return (
    <div
      className={
        'price-tax-total-summary' + (className ? ` ${className}` : '')
      }
    >
      <div className="price-tax-total-metric">
        <span className="price-tax-total-metric-label">
          {t('NonRxCatalog.PriceBreakdown', { defaultValue: 'Price' }).replace(
            /:$/,
            ''
          )}
        </span>
        <span className="price-tax-total-metric-value">
          {formatUsd(priceValue)}
          {eachSuffix}
        </span>
      </div>
      <div className="price-tax-total-metric">
        <span className="price-tax-total-metric-label">
          {t('NonRxCatalog.TaxBreakdown', { defaultValue: 'Tax' }).replace(
            /:$/,
            ''
          )}
        </span>
        <span className="price-tax-total-metric-value">
          {formatUsd(taxValue)}
          {isPercent ? ' (%)' : ''}
          {eachSuffix}
        </span>
      </div>
      <div className="price-tax-total-metric is-total">
        <span className="price-tax-total-metric-label">
          {t('NonRxCatalog.TotalBreakdown', { defaultValue: 'Total' }).replace(
            /:$/,
            ''
          )}
        </span>
        <span className="price-tax-total-metric-value">
          {formatUsd(totalValue)}
          {eachSuffix}
        </span>
      </div>
    </div>
  );
};

PriceTaxTotalSummary.propTypes = {
  t: PropTypes.func.isRequired,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isPercent: PropTypes.bool,
  showEach: PropTypes.bool,
  className: PropTypes.string,
};

PriceTaxTotalSummary.defaultProps = {
  price: 0,
  tax: 0,
  isPercent: false,
  showEach: false,
  className: '',
};

export default PriceTaxTotalSummary;



// WEBPACK FOOTER //
// ./src/components/non-rx-catalog/PriceTaxTotalSummary.js